import { CCBoolean, Component, _decorator } from 'cc';
import { Orientation } from '../../../OrientationManager';
import OrientedComponent from './OrientedComponent';

const { ccclass, property } = _decorator;

@ccclass
export default class OrientationController extends Component {
    private _editLandscapeMode: boolean = true;

    @property({ type: CCBoolean })
    public set editLandscapeMode(mode: boolean) {
        this._editLandscapeMode = mode;
        this.getComponentsInChildren('OrientedComponent').forEach((comp: OrientedComponent<any>) => {
            comp.onOrientationChanged(mode ? Orientation.Landscape : Orientation.Portrait);
        });
    }
    public get editLandscapeMode() {
        return this._editLandscapeMode;
    }

    // 提供給 Extension 的按鈕使用
    private _setLandscape() {
        this.getComponentsInChildren('OrientedComponent').forEach((comp: OrientedComponent<any>) => {
            comp.onOrientationChanged(Orientation.Landscape);
        });
    }

    // 提供給 Extension 的按鈕使用
    private _setPortrait() {
        this.getComponentsInChildren('OrientedComponent').forEach((comp: OrientedComponent<any>) => {
            comp.onOrientationChanged(Orientation.Portrait);
        });
    }
}
